<template>
  <div ref="chart" class="chart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: ['dataTemperature', 'dataBreathe', 'label'],
  data() {
    return {}
  },
  mounted() {
    this.renderChart()
  },
  methods: {
    renderChart() {
      const chart = echarts.init(this.$refs.chart)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', snap: true },
        },
        legend: {},
        xAxis: {
          type: 'category',
          data: this.label,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: [
          {
            name: '℃',
            type: 'value',
            position: 'left',
            min: 35,
            max: 40,
          },
          {
            name: '次/分鐘',
            type: 'value',
            position: 'right',
            min: 0,
            max: 25,
          },
        ],
        series: [
          {
            name: '體溫',
            data: this.dataTemperature,
            yAxisIndex: 0,
            color: '#79155B',
            type: 'line',
            label: {
              show: true,
              position: 'top',
            },
          },
          {
            name: '呼吸',
            data: this.dataBreathe,
            yAxisIndex: 1,
            color: '#157933',
            type: 'line',
            label: {
              show: true,
              position: 'top',
            },
          },
        ],
      }
      chart.setOption(option)
    },
  },
  watch: {
    label() {
      this.renderChart()
    },
    dataTemperature() {
      this.renderChart()
    },
    dataBreathe() {
      this.renderChart()
    },
  },
}
</script>
<style scoped>
.chart {
  width: 600px;
  height: 400px;
}

@media (max-width: 600px) {
  .chart {
    width: 100vw;
    height: 100vw;
  }
}
</style>
